import { useMutation, useQuery } from '@tanstack/react-query'
import type {
	ChangePasswordRequest,
	ForceChangePasswordRequest,
	LoginRequest,
} from '@/types/auth'
import {
	changePassword,
	forceChangePassword,
	getMe,
	login,
	logout,
} from '../services/auth'

export function useLogin() {
	return useMutation({
		mutationFn: (data: LoginRequest) => login(data),
	})
}

export function useLogout() {
	return useMutation({
		mutationFn: (refreshToken: string) => logout({ refreshToken }),
	})
}

export function useMe(enabled = true) {
	return useQuery({
		queryKey: ['auth', 'me'],
		queryFn: getMe,
		enabled,
		retry: false,
		staleTime: 5 * 60 * 1000,
	})
}

export function useForceChangePassword() {
	return useMutation({
		mutationFn: (data: ForceChangePasswordRequest) => forceChangePassword(data),
	})
}

export function useChangePassword() {
	return useMutation({
		mutationFn: (data: ChangePasswordRequest) => changePassword(data),
	})
}
